import {BankDao} from '../../dao';
import {ErrorModel, BankModel} from '../../models';
import { Bank } from '../../models/bank/bank';
import { UserState } from '../../reducers/UserReducer';
import {SERVICE_CODE} from './_serviceCode';

const FUNCTION_CODE = 'GET_ALL_BANKS';

export async function getAllBanks(
    userData: UserState["userProfileData"],
    params: string,
    page: number
) {
    try {
        const banks = await BankDao.getAllBanks(userData?.userToken as string, params, page);

        const bankParsed: Bank[] = banks.results.map((bank: Record<string, any>) => BankModel.parseBank(bank));

        return bankParsed;
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
    }
}
